var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiHeadRemove1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.224 48.3515C81.3307 56.6294 63.2584 86.7412 69.9103 118.07L59.9096 142.534C58.9371 145.409 61.6523 149.038 64.9042 148.167L77.099 144.899L83.6342 169.289C86.0305 178.232 95.3079 183.588 104.251 181.192L112.381 179.013L118.916 203.403L175.825 188.154L165.587 149.944C182.702 135.773 190.482 112.776 184.382 90.0119C175.886 58.3054 143.931 39.8558 112.224 48.3515ZM149.992 121.011L128.344 108.513L115.846 130.16L101.415 121.828L113.913 100.181L92.2654 87.6824L100.597 73.2509L122.245 85.749L134.743 64.1016L149.175 72.4337L136.676 94.081L158.324 106.579L149.992 121.011Z",
    fill: "#7A51AE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiHeadRemove1);
export default __webpack_public_path__ + "static/media/mdi_head-remove (1).095de892801c7d315878e7237a96ae12.svg";
export { ForwardRef as ReactComponent };